import { useEffect, useRef, useState } from "react";

import { IS_WEB_VIEW } from "@/shared/lib/";

export const useKeyboardDetection = () => {
  const [isKeyboardOpen, setIsKeyboardOpen] = useState(false);
  const isKeyboardOpenRef = useRef(false);

  useEffect(() => {
    if (!IS_WEB_VIEW) {
      return;
    }

    const adjustForKeyboard = () => {
      const activeElement = document.activeElement;
      if (
        isKeyboardOpenRef.current &&
        activeElement &&
        (activeElement.tagName === "INPUT" ||
          activeElement.tagName === "TEXTAREA")
      ) {
        activeElement.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    };

    const handleResize = () => {
      const currentHeight = window.innerHeight;
      const screenHeight = window.screen.height;
      const keyboardOpen = currentHeight < screenHeight * 0.75;

      setIsKeyboardOpen(keyboardOpen);
      isKeyboardOpenRef.current = keyboardOpen;
    };

    const handleVisualViewportResize = () => {
      const keyboardOpen =
        (window.visualViewport?.height ?? 0) < window.innerHeight;

      setIsKeyboardOpen(keyboardOpen);
      isKeyboardOpenRef.current = keyboardOpen;
    };

    window.addEventListener("resize", handleResize);
    document.addEventListener("touchstart", adjustForKeyboard);

    if (window.visualViewport) {
      window.visualViewport.addEventListener(
        "resize",
        handleVisualViewportResize,
      );
    }

    return () => {
      window.removeEventListener("resize", handleResize);
      document.removeEventListener("touchstart", adjustForKeyboard);

      if (window.visualViewport) {
        window.visualViewport.removeEventListener(
          "resize",
          handleVisualViewportResize,
        );
      }
    };
  }, []);

  return { isKeyboardOpen };
};
